/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Forward1': {
    width: 23,
    height: 25,
    viewBox: '0 0 23 25',
    data: '<path pid="0" d="M11.6 24.653c-5.908 0-10.8-4.892-10.8-10.8C.8 8.643 4.6 4.228 9.556 3.254V1.751c0-.752.52-.953 1.09-.54l3.379 2.36c.487.34.497.848 0 1.197L10.658 7.14c-.583.424-1.102.223-1.102-.54V5.086c-4.002.91-6.946 4.479-6.946 8.767 0 4.998 3.992 9 8.99 9a8.959 8.959 0 009-9c-.01-3.007-1.472-5.665-3.727-7.274-.434-.328-.572-.826-.307-1.27.265-.435.847-.551 1.313-.191 2.72 1.98 4.52 5.177 4.52 8.735 0 5.908-4.902 10.8-10.8 10.8z" _fill="#00204D" _stroke="#00204D" stroke-width=".6"/>'
  }
})
